import { cn } from '@bem-react/classname';

export const cnTumbler = cn('Tumbler');
